(function () {
  if (!window.HbElements) return;

  class HbHeaderMenu extends HbElements.Component {
    onConnect() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details) return;
      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);
      this.onKey = this.onKey.bind(this);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('keydown', this.onKey);
    }

    onDisconnect() {
      this.removeEventListener('mouseenter', this.onEnter);
      this.removeEventListener('mouseleave', this.onLeave);
      this.removeEventListener('focusin', this.onEnter);
      this.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('keydown', this.onKey);
    }

    onEnter() {
      this.details.open = true;
    }

    onLeave() {
      this.details.open = false;
    }

    onFocusOut(event) {
      if (this.contains(event.relatedTarget)) return;
      this.details.open = false;
    }

    onKey(event) {
      if (event.key !== 'Escape' || !this.details.open) return;
      event.preventDefault();
      this.details.open = false;
      if (this.summary) this.summary.focus();
    }
  }

  HbElements.define('hb-header-menu', HbHeaderMenu);
})();
